import DateRangeFacetDetails from './DateRangeFacetDetails';
import { dateTag } from './tag';
import { makeCriteriaProvider } from './enhancers';

export default {
  tag: dateTag,
  makeCriteriaProvider,
  DetailsControl: DateRangeFacetDetails
};
